<template>
    <div class="app-shell">
        <AppHeader />
        <main>
            <slot />
        </main>
        <AppFooter />
    </div>
</template>

<script setup>
import { computed, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRoute } from 'vue-router'
import AppHeader from '@/components/AppHeader.vue'
import AppFooter from '@/components/AppFooter.vue'

const { t, locale } = useI18n()
const route = useRoute()

const pageTitle = computed(() => {
    const key = route.meta?.titleKey
    const siteName = t('meta.siteName')
    if (!key) return siteName
    const localized = t(key)
    if (key === 'meta.siteName') return `${siteName} — ${t('meta.tagline')}`
    return `${siteName} — ${localized}`
})

watch(
    [pageTitle, locale],
    () => {
        if (typeof document !== 'undefined') {
            document.title = pageTitle.value
        }
    },
    { immediate: true }
)
</script>
